export default "__VITE_ASSET__ba20c722__"